import React, { PureComponent } from 'react';
import { fetchTwoFactorAuth, postResetTwoFactorAuth, postTwoFactorVerifiedAuth } from '../../../../authentication/api';
import { actionTypeEnum } from '../../../../authentication/consts';

const AuthenticationTwoStepController = (OriginalComponent) =>
	class extends PureComponent {
		state = {
			authAppData: {},
			errors: null,
			isPending: false,
			isConfirmationResetTwoStepAuth: false,
		};

		componentDidMount() {
			this.fetchNextAuthStep();
		}

		fetchNextAuthStep = () => {
			const { actionType, isPersistent } = this.props;

			if (
				actionType === actionTypeEnum.TWO_FACTOR_AUTH_REQUIRED ||
				actionType === actionTypeEnum.CHECK_AUTH_CODE
			) {
				this.getNecessaryAction();
			}

			if (actionType === actionTypeEnum.TWO_FACTOR_AUTH_VERIFIED) {
				this.setState({
					isPending: true,
				});

				postTwoFactorVerifiedAuth({ isPersistent }).then(this.handleSuccess).catch(this.handleError);
			}
		};

		getNecessaryAction = () => {
			this.setState({
				isPending: true,
			});

			fetchTwoFactorAuth().then(this.handleSuccess).catch(this.handleError);
		};

		handleSuccess = ({ data }) => {
			this.setState({
				authAppData: data,
				isPending: false,
			});

			if (data.action !== actionTypeEnum.SET_UP_AUTH_APP) {
				this.props.authenticationSetActionType(data.action);
			}
		};

		handleError = ({
			response: {
				data: { errors },
			},
		}) => {
			if (errors) {
				if (errors._) {
					if (errors._.sessionExpired) {
						this.props.authenticationSetActionType(actionTypeEnum.SESSION_EXPIRED);
						return;
					}
					if (errors._.checkCodeAttemptsExceeded) {
						this.props.authenticationSetActionType(actionTypeEnum.CHECK_CODE_ATTEMPTS_EXCEEDED);
						return;
					}
					if (errors._.cannotSendSms) {
						this.props.authenticationSetActionType(actionTypeEnum.CAN_NOT_SEND_SMS);
						return;
					}
				}
				this.setState({
					errors,
					isPending: false,
				});
				return;
			}
			this.props.authenticationSetActionType(actionTypeEnum.SORRY_AN_ERROR_OCCURRED);
			this.setState({
				isPending: false,
			});
		};

		handleAuthAppSend = (values) => {
			this.setState({
				isPending: true,
			});

			postTwoFactorVerifiedAuth(values).then(this.handleSuccess).catch(this.handleError);
		};

		handleShowConfirmationReset = () => {
			this.setState({
				isConfirmationResetTwoStepAuth: true,
			});
		};

		handleHideConfirmationReset = () => {
			this.setState({
				isConfirmationResetTwoStepAuth: false,
			});
		};

		handleResetAuthenticatorApp = () => {
			this.setState({
				isConfirmationResetTwoStepAuth: false,
				isPending: true,
			});

			postResetTwoFactorAuth()
				.then(({ data }) => {
					if (data.action === actionTypeEnum.TWO_FACTOR_AUTH_REQUIRED) {
						this.getNecessaryAction();
					} else {
						this.props.authenticationSetActionType(data.action);

						this.setState({
							authAppData: data,
							isPending: false,
						});
					}
				})
				.catch(this.handleError);
		};

		render() {
			return (
				<OriginalComponent
					{...this.state}
					{...this.props}
					handleAuthAppSend={this.handleAuthAppSend}
					handleShowConfirmationReset={this.handleShowConfirmationReset}
					handleHideConfirmationReset={this.handleHideConfirmationReset}
					handleResetAuthenticatorApp={this.handleResetAuthenticatorApp}
				/>
			);
		}
	};

export default AuthenticationTwoStepController;
